(function () {
  let isInitialized = false;

  window.addEventListener("DOMContentLoaded", () => {
    if (!isInitialized) {
      isInitialized = true;
      init();
    }
  });

  const init = () => {
    const els = document.querySelectorAll(".js-accordion-group");
    [...els].forEach(setupAccordionGroup);
  };

  const setupAccordionGroup = (el) => {
    const group = createGroup(el);

    const handleKeydown = (e) => {
      switch (e.key) {
        case "Up": // IE/Edge specific value
        case "ArrowUp": {
          e.preventDefault();
          return group.focusPrevious(e.currentTarget);
        }
        case "Down": // IE/Edge specific value
        case "ArrowDown": {
          e.preventDefault();
          return group.focusNext(e.currentTarget);
        }
        case "Home": {
          e.preventDefault();
          return group.focusFirst();
        }
        case "End": {
          e.preventDefault();
          return group.focusLast();
        }
      }
    };

    group.on("keydown", handleKeydown);
  };

  const createGroup = (container) => {
    const controllers = [
      ...container.querySelectorAll(".js-accordion-controller"),
    ];

    const setFocus = (index) => controllers[index].focus();

    const moveFocus = (index, direction) => {
      const length = controllers.length;
      setFocus((index + length + direction) % length);
    };

    const focusPrevious = (controller) => {
      const currentIndex = controllers.indexOf(controller);
      moveFocus(currentIndex, -1);
    };

    const focusNext = (controller) => {
      const currentIndex = controllers.indexOf(controller);
      moveFocus(currentIndex, 1);
    };

    const focusFirst = () => setFocus(0);
    const focusLast = () => setFocus(controllers.length - 1);

    return {
      focusPrevious,
      focusNext,
      focusFirst,
      focusLast,
      on(event, handler) {
        controllers.forEach((controller) =>
          controller.addEventListener(event, handler)
        );

        return () =>
          controllers.forEach((controller) =>
            controller.removeEventListener(event, handler)
          );
      },
    };
  };
})();
